export default __webpack_public_path__ + "static/media/point-status-1.fe181811.svg";